<template>
    <div>
        <el-dialog
            :title="title"
            v-model="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" >
                <el-row>
                    <el-form-item label="考勤对象：" prop="peopel">
                        <el-radio-group v-model="Dform.peopel">
                            <el-radio label="0" >学生</el-radio>
                            <el-radio label="1" >教师</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row >
                    <el-form-item label="星期："  prop="days">
                      <el-checkbox-group v-model="checkList" disabled v-if="JSON.stringify(this.xiugaiItem) != '{}'">
                        <el-checkbox label="1">一</el-checkbox>
                        <el-checkbox label="2">二</el-checkbox>
                        <el-checkbox label="3">三</el-checkbox>
                        <el-checkbox label="4">四</el-checkbox>
                        <el-checkbox label="5">五</el-checkbox>
                        <el-checkbox label="6">六</el-checkbox>
                        <el-checkbox label="7">日</el-checkbox>
                    
                    </el-checkbox-group>
                    <el-checkbox-group v-model="checkList" v-else>
                        <el-checkbox label="1">一</el-checkbox>
                        <el-checkbox label="2">二</el-checkbox>
                        <el-checkbox label="3">三</el-checkbox>
                        <el-checkbox label="4">四</el-checkbox>
                        <el-checkbox label="5">五</el-checkbox>
                        <el-checkbox label="6">六</el-checkbox>
                        <el-checkbox label="7">日</el-checkbox>
                    
                    </el-checkbox-group>
                    </el-form-item>
                </el-row>
            <el-row>
                <el-form-item label="上午：" >
                    <el-time-picker
                        v-model="amEnterTime"
                         value-format="HH:mm"
                        placeholder="开始">
                    </el-time-picker>
                    <el-time-picker
                        v-model="amLeaveTime"
                         value-format="HH:mm"
                        placeholder="结束">
                    </el-time-picker>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="下午：" >
                    <el-time-picker
                        v-model="pmEnterTime"
                         value-format="HH:mm"
                        placeholder="开始">
                    </el-time-picker>
                    <el-time-picker
                        v-model="pmLeaveTime"
                         value-format="HH:mm"
                        placeholder="结束">
                    </el-time-picker>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="晚上：" >
                    <el-time-picker
                        v-model="nightEnterTime"
                         value-format="HH:mm"
                        placeholder="开始">
                    </el-time-picker>
                    <el-time-picker
                        v-model="nightLeaveTime"
                         value-format="HH:mm"
                        placeholder="结束">
                    </el-time-picker>
                </el-form-item>
            </el-row>
                <div class="buttom-box">
                        <el-button type="primary" @click="tijiao()">提交</el-button>
                        <el-button @click="handleClose">返回</el-button>    
                    </div>
        </el-form>
            
        </el-dialog>
    </div>
</template>
<script>
import {attendanceTimeSet,attendanceTimeUpdate} from '@/assets/api/schoollog';

export default {
    components: {
    },
    props: ['SchoolId','xiugaiItem'],
    data() { 

        return {
            dialogVisible: true,
            title:'',
            Dform:{
                peopel:'0',
            },
            cardid:"",
            amEnterTime:'', // 上午进校
            amLeaveTime:'', // 上午出校
            pmEnterTime:'', // 下午进校
            pmLeaveTime:'', // 下午出校
            nightEnterTime:'', // 晚上进
            nightLeaveTime:'', // 晚上出
            schoolList:[],
            checkList: [],
            rules:{
                addTime: [
                    { required: true, message: '发布时间', trigger: 'change' }
                ],
            },
        }

    },
    created(){
       console.log(this.SchoolId,78777777777777);
        if ( JSON.stringify(this.xiugaiItem) != '{}' ) {
            this.title = '修改考勤'
            this.Dform.peopel = this.xiugaiItem.attendanceUserType.toString()
            this.checkList = [this.xiugaiItem.day.toString()]
            this.amEnterTime = this.xiugaiItem.amEnterTime
            this.amLeaveTime = this.xiugaiItem.amLeaveTime
            this.pmEnterTime = this.xiugaiItem.pmEnterTime
            this.pmLeaveTime = this.xiugaiItem.pmLeaveTime
            this.nightEnterTime = this.xiugaiItem.nightEnterTime
            this.nightLeaveTime = this.xiugaiItem.nightLeaveTime
            console.log(this.Dform.peopel,this.checkList,789789);
        } else {
            this.title = '添加考勤'
        }
    },
    mounted(){
        console.log(this.xiugaiItem,'修改item');
    },
    methods:{
        handleClose() {
            this.$emit('FatcherClick')
        },
        tijiao () {
            // console.log(this.amEnterTime,11,this.amEnterTime == 'null',this.amEnterTime == null)
            if ( (this.amEnterTime == '' || this.amEnterTime == null ) || (this.amLeaveTime == ''||this.amLeaveTime == null)  ) {
                this.$message({
                    type: 'error',
                    message: '上午时间请选择完整'
                });
                return
            } else if ( (this.pmEnterTime == ''||this.pmEnterTime == null) || (this.pmLeaveTime == '' || this.pmLeaveTime == null) ) {
                this.$message({
                    type: 'error',
                    message: '下午时间请选择完整'
                });
                return
            }
            if ( JSON.stringify(this.xiugaiItem) != '{}' ) {
                this.xiuagiClick()
            } else {
                this.AddClick()
            }
        },
        AddClick(){
            let params = {
                amEnterTime: this.amEnterTime,
                amLeaveTime: this.amLeaveTime,
                attendanceUserType: this.Dform.peopel,
                days: this.checkList,
                nightEnterTime: this.nightEnterTime,
                nightLeaveTime: this.nightLeaveTime,
                pmEnterTime: this.pmEnterTime,
                pmLeaveTime: this.pmLeaveTime,
                schoolId: this.SchoolId,
                userId:JSON.parse(localStorage.getItem('user')).id,
            }
            attendanceTimeSet(params).then((res)=> {
                // console.log(res,'新增');
                this.$message({
                    type: 'success',		
                    message: '新增成功'
                });
                this.handleClose()
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })
        },
        xiuagiClick () {
            let params = {
                amEnterTime: this.amEnterTime,
                amLeaveTime: this.amLeaveTime,
                attendanceUserType: this.Dform.peopel,
                days: this.checkList,//需要修改
                nightEnterTime: this.nightEnterTime || '',
                nightLeaveTime: this.nightLeaveTime || '',
                pmEnterTime: this.pmEnterTime,
                pmLeaveTime: this.pmLeaveTime,
                // schoolId: this.SchoolId,
                id: this.xiugaiItem.id,
                userId:JSON.parse(localStorage.getItem('user')).id,
            }
            console.log(params,111111111111)
            attendanceTimeUpdate(params).then((res)=> {
                this.$message({
                    type: 'success',		
                    message: '修改成功'
                });
                this.handleClose()
            }).catch((err)=> {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        }

        }
    }
</script>
<style  scoped lang="scss">
    :deep() {
        .el-dialog__body {
               height: 500px;
                overflow: auto;
                // padding-bottom: 0px;
                padding: 10px 10px;
                font-size: 14px;
            }
        .el-dialog__title {
            font-weight: 700;
            }
        .el-input--small .el-input__wrapper{
            height: 34px;
            line-height: 35px;
            text-align: center;
            // width: 350px;
            border-radius: 15px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        [data-v-cc9654b4] .el-input--small {
            height: 40px;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 230px;
        margin-top: 30px;

    }
    .el-form-item--small .el-form-item__label{
        font-size: 14px;
        font-weight: 700;
        // color: ;
    }
    .el-input--small{
        margin-right: 10px;
    }
    .el-input__wrapper{
        width: 30% !important;
    }
    
    .el-form-item--small{
        // width: 70% !important;
        margin: 15px !important;
        font-size: 18px;
    }
    }
</style>